import React from 'react'
import { PositionName } from '@src/modules/Positions/shared/PositionName'

interface SingleAnnouncementHistoryProps {
  msg: {
    title: string
    body: string
    cts: string | Date
    mts: string | Date
    positions: string[]
  }
  onClick?: () => void
  onDelete?: () => void
  isDeleting?: boolean
}

function SingleAnnouncementHistory({msg, onClick, onDelete, isDeleting}: SingleAnnouncementHistoryProps) {
    const [confirmDelete, setConfirmDelete] = React.useState(false)
    return (
        <div className='flex gap-4 px-4 py-3 bg-white group hover:bg-gray-100 cursor-pointer items-center' onClick={onClick}>
            <div className='flex flex-col gap-1 w-2/3'>
                <div className='font-semibold'>{msg.title}</div>
                <div className='flex gap-1'>
                    {msg.positions && msg.positions.map((position, index) => (
                        <div className='flex items-center bg-gray-300 px-4 py-1 rounded-md text-sm' key={position}>
                            <PositionName id={position} />
                        </div>
                    ))} 
                </div>
                <div className='text-sm text-gray-500'>{msg.body}</div>
            </div>
            <div className="w-1/3 flex items-center justify-between">
                <div className='text-sm text-gray-500'>{new Date(msg.cts).toLocaleString()}</div>
                {onDelete && (
                    confirmDelete ? (
                        <button
                            type="button"
                            className="ml-2 px-1 py-1 text-xs cursor-pointer text-white bg-red-500 rounded hover:bg-red-600 transition-opacity"
                            disabled={isDeleting}
                            onClick={e => {
                                e.stopPropagation()
                                setConfirmDelete(false)
                                onDelete()
                            }}
                        >
                            Confirm
                        </button>
                    ) : (
                        <button
                            type="button"
                            className="ml-2 text-gray-400 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity"
                            onClick={e => {
                                e.stopPropagation()
                                setConfirmDelete(true)
                                setTimeout(() => setConfirmDelete(false), 2500)
                            }}
                            aria-label="Delete message"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    )
                )}
            </div>
        </div>
    )
}

export default SingleAnnouncementHistory
